import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { useLang } from "@/i18n";

export default function ClinicalCases() {
  const c = useLang().t.cases;
  return (
    <>
      <Seo page="cases" />
      <PageIntro testId="cases-intro" overline={c.overline} title={c.title} lead={c.lead} />
      <section data-testid="cases-placeholder" className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="p-8 rounded-2xl border border-[#D3CEC4] bg-[#EAE5D9]/50" data-testid="cases-status">
            <p className="text-[10px] tracking-[0.28em] uppercase font-semibold text-[#374F49]">{c.statusLabel}</p>
            <p className="font-serif text-2xl mt-3 text-[#1A2522]">{c.status}</p>
            <p className="mt-4 text-sm text-[#495854] leading-relaxed">{c.disclaimer}</p>
          </div>
        </div>
      </section>
    </>
  );
}
